import React, { useEffect, useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap';

import styles from './GenericModal.module.css';

const GenericModal = (props) => {
  const [modalType, setModalType] = useState(props.modalType);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    switch (props.modalType) { 
      case 'confirmation':
        setModalType('confirmation')
        break;
      case 'notification':
        setModalType('notification')
        break;
      case 'error':
        setModalType('error') 
        break;
      default:
        break;
    }
  }, [props.modalType])

  useEffect(() => {
  if (props.show) {
    setInputValue(""); // Reset quando la modale viene aperta
  }
}, [props.show]);

  const handleAction = () => {
    props.handleClose();
    if (props.action != undefined) {
      props.action(modalType === 'confirmation' && props.showInput ? inputValue : undefined);
    }
  }

  let bodyText = props.message;
  const bodyIsArray = Array.isArray(props.message);
  if (bodyIsArray) {
    bodyText = <ul>
      {props.message.map((el, index) => (
        <li key={index}>{el}</li>
      ))}
    </ul>
  }

  if (bodyText && (typeof bodyText === "string")) {
    let match = /\r|\n/.exec(bodyText);
    if (match) {
      let lines = bodyText.split(/\r?\n/);
      bodyText = <div>
        {lines.map((line, index) => {
          let isAlert = false;
          let updatedLine = line;
          if (line.includes("WARNING_TEXT:")) {
            isAlert = true;
            updatedLine = line.replace("WARNING_TEXT:", "");
          }
          return (
            <p key={index} className={`${isAlert ? "text-danger" : ""} m-0`}>{updatedLine}</p>
          );
        })}
      </div>
    } else {
      let isAlert = false;
      let updatedText = bodyText;
      if (bodyText.includes("WARNING_TEXT:")) {
        isAlert = true;
        updatedText = bodyText.replace("WARNING_TEXT:", "");
      }
      bodyText = <div className={`${isAlert ? "text-danger" : ""} m-0`}>
        {updatedText}
      </div>
    }
  }

  return (
    <div>
      {modalType === 'confirmation' && (
        <Modal centered show={props.show} onHide={props.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className={`${styles.modalHeader} ps-1`}>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="ps-4">
            {bodyText}
            {props.showInput && (
              <Form.Control
                type="text"
                placeholder="Insert comment"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="mt-3"
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="me-2" variant="primary" onClick={handleAction}>
              Confirm
            </Button>
            <Button variant="secondary" onClick={props.handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {(modalType === 'notification' || modalType === 'error') && (
        <Modal centered show={props.show} onHide={handleAction}>
          {props.title && (
            <Modal.Header closeButton>
              <Modal.Title className={`${styles.modalHeader} ps-1`}>{props.title}</Modal.Title>
            </Modal.Header>
          )}
          <Modal.Body
            className={`d-flex justify-content-center ${
              modalType === 'error' ? "text-danger" : ""
            } ${!bodyIsArray ? "text-center" : ""}`}
          >
            {bodyText}
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button variant="primary" onClick={handleAction}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default GenericModal;
